import { castIdRouteParams } from '../helpers/helpers';

export default [
    {
        path: '/registers/organizers',
        name: 'organizers',
        component: () => import('../views/registers/organizers/List.vue'),
        meta: { claims: [{ name: 'organizersRegister', crud: 'read' }] }
    },
    {
        path: '/registers/organizer/create',
        name: 'createOrganizer',
        component: () => import('../views/registers/organizers/Organizer.vue'),
        meta: { claims: [{ name: 'organizersRegister', crud: 'create' }] }
    },
    {
        path: '/registers/organizer/:id/edit',
        name: 'editOrganizer',
        component: () => import('../views/registers/organizers/Organizer.vue'),
        meta: { claims: [{ name: 'organizersRegister', crud: 'update' }] },
        props: castIdRouteParams
    },
    {
        path: '/registers/organizer/:id/details',
        name: 'detailsOrganizer',
        component: () => import('../views/registers/organizers/Details.vue'),
        meta: { claims: [{ name: 'organizersRegister', crud: 'read' }] },
        props: (route) => ({ id: Number.parseInt(route.params.id, 10), returnUrl: route.query.returnUrl }),
    },
    {
        path: '/registers/places',
        name: 'places',
        component: () => import('../views/registers/places/List'),
        meta: { claims: [{ name: 'venuesRegister', crud: 'read' }] },
        props: castIdRouteParams
    },
    {
        path: '/registers/place/create',
        name: 'placesCreate',
        component: () => import('../views/registers/places/Places'),
        meta: { claims: [{ name: 'venuesRegister', crud: 'create' }] },
        props: castIdRouteParams
    },
    {
        path: '/registers/place/:id/edit',
        name: 'placesEdit',
        component: () => import('../views/registers/places/Places'),
        meta: { claims: [{ name: 'venuesRegister', crud: 'update' }] },
        props: castIdRouteParams
    },
    {
        path: '/registers/place/:id/details',
        name: 'placesDetails',
        component: () => import('../views/registers/places/Details'),
        meta: { claims: [{ name: 'venuesRegister', crud: 'read' }] },
        props: (route) => ({ id: Number.parseInt(route.params.id, 10), returnUrl: route.query.returnUrl }),
    },
    {
        path: '/registers/accommodationPlaces',
        name: 'accommodationPlaces',
        component: () => import('../views/registers/accommodationPlaces/List.vue'),
        meta: { claims: [{ name: 'accommodationPlacesRegister', crud: 'read' }] }
    },
    {
        path: '/registers/accommodationPlace/create',
        name: 'newAccommodation',
        component: () => import('../views/registers/accommodationPlaces/AccommodationPlaces.vue'),
        meta: { claims: [{ name: 'accommodationPlacesRegister', crud: 'create' }] }
    },
    {
        path: '/registers/accommodationPlace/:id/edit',
        name: 'editAccommodation',
        component: () => import('../views/registers/accommodationPlaces/AccommodationPlaces.vue'),
        meta: { claims: [{ name: 'accommodationPlacesRegister', crud: 'update' }] },
        props: castIdRouteParams
    },
    {
        path: '/registers/accommodationPlace/:id/details',
        name: 'detailsAccommodation',
        component: () => import('../views/registers/accommodationPlaces/Details.vue'),
        meta: { claims: [{ name: 'accommodationPlacesRegister', crud: 'read' }] },
        props: (route) => ({ id: Number.parseInt(route.params.id, 10), returnUrl: route.query.returnUrl }),
    },
    {
        path: '/registers/projects',
        name: 'listProjects',
        component: () => import('../views/registers/projects/List.vue'),
        meta: { claims: [{ name: 'projectsRegister', crud: 'read' }] }
    },
    {
        path: '/registers/project/:id/edit',
        name: 'editProject',
        component: () => import('../views/registers/projects/Project.vue'),
        meta: { claims: [{ name: 'projectsRegister', crud: 'update' }] },
        props: castIdRouteParams
    },
    {
        path: '/registers/project/create',
        name: 'createProject',
        component: () => import('../views/registers/projects/Project.vue'),
        meta: { claims: [{ name: 'projectsRegister', crud: 'create' }] },
        props: castIdRouteParams
    },
    {
        path: '/registers/project/:id/details',
        name: 'detailsProject',
        component: () => import('../views/registers/projects/ProjectDetails.vue'),
        meta: { claims: [{ name: 'projectsRegister', crud: 'read' }] },
        props: (route) => ({ id: Number.parseInt(route.params.id, 10), returnUrl: route.query.returnUrl }),
    },
    {
        path: '/registers/publicOrders',
        name: 'listPublicOrder',
        component: () => import('../views/registers/publicOrders/List.vue'),
        meta: { claims: [{ name: 'publicOrdersRegister', crud: 'read' }] }
    },
    {
        path: '/registers/publicOrders/publicList',
        name: 'publicList',
        component: () => import('../views/registers/publicOrders/PublicOrdersPublicGrid.vue')
    },
    {
        path: '/registers/publicOrder/create',
        name: 'createPublicOrder',
        component: () => import('../views/registers/publicOrders/PublicOrder.vue'),
        meta: { claims: [{ name: 'publicOrdersRegister', crud: 'create' }] }
    },
    {
        path: '/registers/publicOrder/:id/edit',
        name: 'editPublicOrder',
        component: () => import('../views/registers/publicOrders/PublicOrder.vue'),
        meta: { claims: [{ name: 'publicOrdersRegister', crud: 'update' }] },
        props: castIdRouteParams
    },
    {
        path: '/registers/publicOrder/:id/details',
        name: 'detailsPublicOrder',
        component: () => import('../views/registers/publicOrders/PublicOrderDetails.vue'),
        props: (route) => ({ id: Number.parseInt(route.params.id, 10), returnUrl: route.query.returnUrl }),
    },
    {
        path: '/registers/thematicAreas',
        name: 'thematicAreaList',
        component: () => import('../views/registers/thematicAreas/List.vue'),
        meta: { claims: [{ name: 'thematicAreasRegister', crud: 'read' }] },
    },
    {
        path: '/registers/thematicArea/create',
        name: 'createThematicArea',
        component: () => import('../views/registers/thematicAreas/ThematicArea.vue'),
        meta: { claims: [{ name: 'thematicAreasRegister', crud: 'create' }] },
    },
    {
        path: '/registers/thematicArea/:id/edit',
        name: 'editThematicArea',
        component: () => import('../views/registers/thematicAreas/ThematicArea.vue'),
        meta: { claims: [{ name: 'thematicAreasRegister', crud: 'update' }] },
        props: castIdRouteParams
    },
    {
        path: '/registers/thematicArea/:id/details',
        name: 'detailsThematicArea',
        component: () => import('../views/registers/thematicAreas/ThematicAreaDetails.vue'),
        meta: { claims: [{ name: 'thematicAreasRegister', crud: 'read' }] },
        props: (route) => ({ id: Number.parseInt(route.params.id, 10), returnUrl: route.query.returnUrl }),
    },
    {
        path: '/registers/externalSuppliers',
        name: 'listExternalSuppliers',
        component: () => import('../views/registers/externalSupplier/List.vue'),
        meta: { claims: [{ name: 'contractsRegister', crud: 'read' }] }
    },
    {
        path: '/registers/externalSupplier/create',
        name: 'createExternalSuppliers',
        component: () => import('../views/registers/externalSupplier/ExternalSupplier.vue'),
        meta: { claims: [{ name: 'contractsRegister', crud: 'create' }] }
    },
    {
        path: '/registers/externalSupplier/:id/edit',
        name: 'editExternalSuppliers',
        component: () => import('../views/registers/externalSupplier/ExternalSupplier.vue'),
        meta: { claims: [{ name: 'contractsRegister', crud: 'update' }] },
        props: castIdRouteParams
    },
    {
        path: '/registers/externalSupplier/:id/details',
        name: 'detailsExternalSuppliers',
        component: () => import('../views/registers/externalSupplier/ExternalSupplierDetails.vue'),
        meta: { claims: [{ name: 'contractsRegister', crud: 'read' }] },
        props: (route) => ({ id: Number.parseInt(route.params.id, 10), returnUrl: route.query.returnUrl }),
    },
    {
        path: '/registers/activities',
        name: 'listActivities',
        component: () => import('../views/registers/activities/List.vue'),
        meta: { claims: [{ name: 'activitiesRegister', crud: 'read' }] }
    },
    {
        path: '/registers/activity/create',
        name: 'createActivities',
        component: () => import('../views/registers/activities/Activity.vue'),
        meta: { claims: [{ name: 'activitiesRegister', crud: 'create' }] }
    },
    {
        path: '/registers/activity/:id/edit',
        name: 'editActivities',
        component: () => import('../views/registers/activities/Activity.vue'),
        meta: { claims: [{ name: 'activitiesRegister', crud: 'update' }] },
        props: castIdRouteParams
    },
    {
        path: '/registers/activity/:id/details',
        name: 'detailsActivities',
        component: () => import('../views/registers/activities/ActivityDetails.vue'),
        meta: { claims: [{ name: 'activitiesRegister', crud: 'read' }] },
        props: (route) => ({ id: Number.parseInt(route.params.id, 10), returnUrl: route.query.returnUrl }),
    },
    {
        path: '/registers/institutions',
        name: 'listInstitutions',
        component: () => import('../views/registers/institutions/List.vue'),
        meta: { claims: [{ name: 'institutionsRegister', crud: 'read' }] }
    },
    {
        path: '/registers/institution/create',
        name: 'createInstitutions',
        component: () => import('../views/registers/institutions/Institution.vue'),
        meta: { claims: [{ name: 'institutionsRegister', crud: 'create' }] }
    },
    {
        path: '/registers/institution/:id/edit',
        name: 'editInstitutions',
        component: () => import('../views/registers/institutions/Institution.vue'),
        meta: { claims: [{ name: 'institutionsRegister', crud: 'update' }] },
        props: castIdRouteParams
    },
    {
        path: '/registers/institution/:id/details',
        name: 'detailsInstitutions',
        component: () => import('../views/registers/institutions/InstitutionDetails.vue'),
        meta: { claims: [{ name: 'institutionsRegister', crud: 'read' }] },
        props: (route) => ({ id: Number.parseInt(route.params.id, 10), returnUrl: route.query.returnUrl }),
    },
    {
        path: '/registers/administrativePositions',
        name: 'listAdministrativePositions',
        component: () => import('../views/registers/administrativePosition/List.vue'),
        meta: { claims: [{ name: 'nijPositionsRegister', crud: 'read' }] }
    },
    {
        path: '/registers/administrativePosition/create',
        name: 'createAdministrativePosition',
        component: () => import('../views/registers/administrativePosition/AdministrativePosition.vue'),
        meta: { claims: [{ name: 'nijPositionsRegister', crud: 'create' }] }
    },
    {
        path: '/registers/administrativePosition/:id/edit',
        name: 'editAdministrativePosition',
        component: () => import('../views/registers/administrativePosition/AdministrativePosition.vue'),
        meta: { claims: [{ name: 'nijPositionsRegister', crud: 'update' }] },
        props: castIdRouteParams
    },
    {
        path: '/registers/administrativePosition/:id/details',
        name: 'detailsAdministrativePosition',
        component: () => import('../views/registers/administrativePosition/AdministrativePositionDetails.vue'),
        meta: { claims: [{ name: 'nijPositionsRegister', crud: 'read' }] },
        props: (route) => ({ id: Number.parseInt(route.params.id, 10), returnUrl: route.query.returnUrl }),
    },
    {
        path: '/registers/dynamictest',
        name: 'dynamictest',
        component: () => import('../views/test/DynamicRegistersTest.vue')
    },
    {
        path: '/dynamic/create',
        name: 'dynamicRegisterCreate',
        component: () => import('../views/editors/RegistersEditor.vue'),
        meta: { claims: [{ name: 'dynamicRegister', crud: 'create' }] }
    },
    {
        path: '/dynamic/edit/:id',
        name: 'dynamicRegisterEdit',
        component: () => import('../views/editors/RegistersEditor.vue'),
        meta: { claims: [{ name: 'dynamicRegister', crud: 'update' }] },
        props: castIdRouteParams
    },
    {
        path: '/registers/lecturers',
        name: 'listLecturers',
        component: () => import('../views/registers/dynamic/ListDynamicData.vue'),
        props: { registerName: 'lecturers' },
        meta: { claims: [{ name: 'lecturer', crud: 'read' }] },
    },
    {
        path: '/registers/lectors',
        name: 'lectorsList',
        component: () => import('../views/registers/lectors/List.vue'),
        meta: { claims: [{ name: 'lecturer', crud: 'read' }] },
    },
    {
        path: '/registers/lectors/create',
        name: 'lectorsCreate',
        component: () => import('../views/registers/lectors/Lectors.vue'),
        meta: { claims: [{ name: 'lecturer', crud: 'create' }] },
    },
    {
        path: '/registers/lectors/edit/:id',
        name: 'lectorsEdit',
        component: () => import('../views/registers/lectors/Lectors.vue'),
        meta: { claims: [{ name: 'lecturer', crud: 'update' }] },
        props: castIdRouteParams
    },
    {
        path: '/registers/lectors/details/:id',
        name: 'lectorsDetails',
        component: () => import('../views/registers/lectors/LectorsDetails.vue'),
        props: castIdRouteParams
    },
    {
        path: '/registers/participants',
        name: 'listParticipants',
        component: () => import('../views/registers/participants/List.vue'),
        meta: { claims: [{ name: 'participant', crud: 'read' }] }
    },
    {
        path: '/registers/participants/details/:id',
        name: 'participantsDetails',
        component: () => import('../views/registers/participants/ParticipantDetails.vue'),
        meta: { claims: [{ name: 'participant', crud: 'read' }] },
        props: castIdRouteParams
    },
    {
        path: '/registers/events',
        name: 'listEvents',
        component: () => import('../views/registers/dynamic/events/ListEvents.vue'),
        props: { registerName: 'events', archived: false },
        meta: { claims: [{ name: 'event', crud: 'read' }] }
    },
    {
        path: '/registers/events/create',
        name: 'events',
        component: () => import('../views/registers/dynamic/events/Event.vue'),
        props: true,
        meta: { claims: [{ name: 'event', crud: 'create' }] }
    },
    {
        path: '/registers/events/edit/:id',
        name: 'eventsEdit',
        component: () => import('../views/registers/dynamic/events/Event.vue'),
        props: castIdRouteParams
    },
    {
        path: '/registers/events/details/:id',
        name: 'eventDetails',
        component: () => import('../components/dynamic/register/Details.vue'),
        props: castIdRouteParams
    },
    {
        path: '/registers/employee',
        name: 'employeeList',
        component: () => import('../views/registers/employee/List.vue'),
        meta: { claims: [{ name: 'nijEmployee', crud: 'read' }] },
    },
    {
        path: '/registers/employee/organogram',
        name: 'employeesOrganogram',
        component: () => import('../views/registers/employee/Organogram.vue'),
        meta: { claims: [{ name: 'nijEmployee', crud: 'read' }] }
    },
    {
        path: '/registers/employee/create',
        name: 'employeeCreate',
        component: () => import('../views/registers/employee/Employee.vue'),
        meta: { claims: [{ name: 'nijEmployee', crud: 'create' }] },
    },
    {
        path: '/registers/employee/edit/:id',
        name: 'employeeEdit',
        component: () => import('../views/registers/employee/Employee.vue'),
        meta: { claims: [{ name: 'nijEmployee', crud: 'update' }] },
        props: castIdRouteParams
    },
    {
        path: '/registers/employee/details/:id',
        name: 'employeeDetails',
        component: () => import('../views/registers/employee/EmployeeDetails.vue'),
        meta: { claims: [{ name: 'nijEmployee', crud: 'read' }] },
        props: castIdRouteParams
    },
    {
        path: '/registers/theme',
        name: 'eventTheme',
        component: () => import('../views/registers/theme/List.vue'),
        meta: { claims: [{ name: 'eventThemesRegister', crud: 'read' }] }
    },
    {
        path: '/registers/mentor/create',
        name: 'mentorCreate',
        component: () => import('../views/registers/mentors/Mentor.vue'),
        meta: { claims: [{ name: 'mentor', crud: 'create' }] }
    },
    {
        path: '/registers/mentor',
        name: 'mentorList',
        component: () => import('../views/registers/mentors/List.vue'),
        meta: { claims: [{ name: 'mentor', crud: 'read' }] }
    },
    {
        path: '/registers/mentor/edit/:id',
        name: 'mentorEdit',
        component: () => import('../views/registers/mentors/Mentor.vue'),
        meta: { claims: [{ name: 'mentor', crud: 'update' }] },
        props: castIdRouteParams
    },
    {
        path: '/registers/mentor/details/:id',
        name: 'mentorDetails',
        component: () => import('../views/registers/mentors/MentorDetails.vue'),
        meta: { claims: [{ name: 'mentor', crud: 'read' }] },
        props: castIdRouteParams
    },
    {
        path: '/registers/allAppearances',
        name: 'listAllAppearances',
        component: () => import('../views/registers/participants/AllAppearancesList.vue'),
        meta: { claims: [{ name: 'participant', crud: 'read' }] }
    },
    {
        path: '/registers/budgetTemplate/',
        name: 'budgetTemplate',
        component: () => import('../views/budgetTemplate/List.vue'),
        meta: { claims: [{ name: 'eventBudget', crud: 'read' }] }
    },
    {
        path: '/registers/budgetTemplate/create',
        name: 'budgetTemplateCreate',
        component: () => import('../views/budgetTemplate/BudgetTemplate.vue'),
        meta: { claims: [{ name: 'eventBudget', crud: 'create' }] }
    },
    {
        path: '/registers/budgetTemplate/edit/:id',
        name: 'budgetTemplateEdit',
        component: () => import('../views/budgetTemplate/BudgetTemplate.vue'),
        props: castIdRouteParams,
        meta: { claims: [{ name: 'eventBudget', crud: 'update' }] }
    },
    {
        path: '/organizationalModels',
        name: 'organizationalModels',
        component: () => import('../views/organizationalModel/List.vue'),
        meta: { claims: [{ name: 'organizationalModelsRegister', crud: 'read' }] }
    },
    {
        path: '/organizationalModels/edit/:id',
        name: 'organizationalModelEdit',
        component: () => import('../views/organizationalModel/Model.vue'),
        props: castIdRouteParams,
        meta: { claims: [{ name: 'organizationalModelsRegister', crud: 'update' }] }
    },
    {
        path: '/participant/edit',
        name: 'eventParticipantEdit',
        component: () => import('../views/participant/Participant.vue'),
        props: (route) => ({ id: route.query.id, details: false }),
        meta: { claims: [{ name: 'participant', crud: 'update' }] }
    },
    {
        path: '/lecturersElRegister',
        name: 'lecturersElRegister',
        component: () => import('../views/registers/lectors/LecturersElRegister.vue')
    },
    {
        path: '/budgetModule',
        name: 'budgetModule',
        component: () => import('../views/registers/budgetModule/BudgetModule.vue'),
        meta: { claims: [{ name: 'eventBudget', crud: 'read' }] }
    },
    {
        path: '/budgetReport',
        name: 'budgetReport',
        component: () => import('../views/registers/budgetModule/BudgetReport.vue'),
        meta: { claims: [{ name: 'eventBudget', crud: 'read' }] }
    },
    {
        path: '/registers/rankingCriteria',
        name: 'listRankingCriteria',
        component: () => import('../views/registers/rankingCriteria/List.vue'),
        meta: { claims: [{ name: 'rankingCriteriaRegister', crud: 'read' }] }
    },
    {
        path: '/tempRamking/history',
        name: 'tempRankingHistory',
        component: () => import('../views/registers/rankingCriteria/TempRankingHistory.vue'),
        props: (route) => ({ eventId: Number(route.query.eventId) }),
        meta: { claims: [{ name: 'tempRanking', crud: 'read' }] }
    },
]
